export default __webpack_public_path__ + "static/media/sprint-plan.13592331.gif";